// extracted by css-extract-rspack-plugin
export default {"scimHeaderTitle":"Scim_scimHeaderTitle__kFS1y","justify":"Scim_justify__ZSpKg"};